import React from 'react';
import { useMods } from '../lib/mods';
import styled from 'styled-components/macro';

const ModsContainer = styled.div`
  flex: 1;
  flex-direction: column;
  text-align: left;
`;

export function Mods() {
  const mods = useMods();

  if (!mods) {
    return <p>Mods still loading...</p>;
  }

  const modsList = mods.map((mod) => {
    return (
      <div key={mod.name}>
        <h2>{mod.name}</h2>
        {mod.external.about}
      </div>
    );
  });

  return (
    <ModsContainer>
      <h1>Loaded mods</h1>
      {modsList}
    </ModsContainer>
  );
}
